import React, {Component} from 'react';
import Search from '../search/Search';
import Vcard from './Vcard/Vcard';
import * as searchSettings from "../search/settings";
import axios from "axios/index";

export default class ContactExpert extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expertData: null,
            selectedCountry: '',
        };

        this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
        this.getExpertData = this.getExpertData.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.selectedCountry !== prevState.selectedCountry) {
            this.getExpertData();
        }
    }

    handleSuggestionClick(target) {
        this.setState({
            selectedCountry: target.textContent,
        });
    }

    getExpertData() {
        axios.get(searchSettings.apiUrls['marine-products'], {
            params: {
                query: this.state.selectedCountry
            }
        })
        .catch(function (error) {
            if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
            console.log(error.config);
        })
        .then(response => {
            if(response.data) {
                let offices = response.data.map(item => item.Id);

                this.setState({
                    expertData: offices,
                });
            }
        });
    }

    render() {
        let contactContent;

        if(this.state.expertData) {
            if(this.state.expertData.length) {
                contactContent = (
                    <React.Fragment>
                        <ul className="contact-expert__results-list">
                            {this.state.expertData.map(item => {
                                return (
                                    <li key={item}>
                                        <Vcard id={item} key={item} />
                                    </li>
                                );
                            })}
                        </ul>
                    </React.Fragment>
                );
            } else {
                contactContent = (
                    <p>
                        No results found
                    </p>
                );
            }
        }

        return (
            <section className="contact-expert">
                <h2 className="contact-expert__header">
                    <span>
                        Find contact information for Ships Service offices worldwide
                    </span>
                </h2>
                <fieldset className="contact-expert__search">
                    <legend className="contact-expert__description">
                        <span>
                            Enter your company location
                        </span>
                    </legend>
                    <Search
                        placeholder="Enter country name"
                        defaultValue={this.state.selectedCountry}
                        buttonType="search"
                        searchType="country"
                        handleSuggestionClick={this.handleSuggestionClick}/>
                </fieldset>
            </section>
        );
    }
}
